import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n/i18n';
import './styles/global.css';
import './App.css';
import IntroAnimation from './components/IntroAnimation';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import WatchDetailPage from './pages/WatchDetailPage';
import ContactPage from './pages/ContactPage';
import AdminPage from './pages/AdminPage';
import NotFoundPage from './pages/NotFoundPage';
import LanguageSwitcher from './components/LanguageSwitcher';
import { initializeWatchData } from './utils/watchData';
// import FirestoreTest from './FirestoreTest';
// import CreateWatchesCollection from './CreateWatchesCollection';

function App() {
  const [showIntro, setShowIntro] = useState(true);
  const [introComplete, setIntroComplete] = useState(false);

  useEffect(() => {
    // Initialize watch data at app start
    initializeWatchData();
    
    // Add scroll animation observer
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        }
      });
    }, { threshold: 0.1 });

    const fadeElements = document.querySelectorAll('.fade-in');
    fadeElements.forEach(element => {
      observer.observe(element);
    });

    return () => {
      fadeElements.forEach(element => {
        observer.unobserve(element);
      });
    };
  }, []);

  const handleIntroComplete = () => {
    setIntroComplete(true);
    setTimeout(() => {
      setShowIntro(false); // Remove the intro from DOM after animation completes
    }, 300);
  };

  // Hide all content until intro is complete
  const contentStyle = {
    opacity: introComplete ? 1 : 0,
    transition: 'opacity 1s ease',
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  };

  return (
    <HelmetProvider>
    <I18nextProvider i18n={i18n}>
      <Router>
        {showIntro && <IntroAnimation onComplete={handleIntroComplete} />}
        
        <div className="app" style={contentStyle}>
          <header className="app-header">
            <div className="container">
              <div className="header-content">
                <Link to="/" className="logo shiny-logo">KAIN</Link>
                <LanguageSwitcher />
              </div>
            </div>
          </header>
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/watches/:id" element={<WatchDetailPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/admin" element={<AdminPage />} />
              {/* <Route path="/test" element={<FirestoreTest />} />
              <Route path="/create-collection" element={<CreateWatchesCollection />} /> */}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </I18nextProvider>
    </HelmetProvider>
  );
}

export default App;
